import React from 'react'
import { itemsClientesHome } from '../../../utils/itemsClientesHome'
import ItemHomeCliente from '../ItemHomeCliente'

export default function CarruselClient() {
    return (
        <div className="carrusel_Cliente">
            <div className="slider">
                <div className="slide-track">
                    {itemsClientesHome.map((item) =>
                        <div className="slide" key={item.id}>
                            <ItemHomeCliente image={item.image} />
                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}
